import React from 'react'
import PropTypes from 'prop-types';

export default function PrintPdf(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7.514 15.097c0-.359-.249-.573-.688-.573-.18 0-.3.018-.364.035v1.151c.075.017.168.022.295.022.468 0 .757-.236.757-.635Zm2.719-.56c-.197 0-.324.017-.399.034v2.55a1.6 1.6 0 0 0 .306.017c.798.005 1.319-.434 1.319-1.364.005-.81-.469-1.237-1.226-1.237Z"
        fill="#FFF"
      />
      <path
        d="M15.284 1.2H6.609a2.302 2.302 0 0 0-2.3 2.3V12h-.224a.926.926 0 0 0-.926.927v5.618c0 .512.415.926.926.926h.225v1.03a2.301 2.301 0 0 0 2.299 2.3h11.837a2.301 2.301 0 0 0 2.298-2.3V6.641l-5.46-5.44ZM5.589 13.94c.271-.045.653-.08 1.19-.08.544 0 .931.104 1.192.312.248.196.416.52.416.902 0 .381-.127.705-.359.925-.3.283-.745.41-1.266.41-.115 0-.22-.006-.3-.017v1.393h-.873V13.94Zm12.857 7.452H6.609c-.491 0-.89-.4-.89-.89v-1.03h11.034a.926.926 0 0 0 .926-.927v-5.618a.926.926 0 0 0-.926-.927H5.718V3.5c0-.49.4-.89.89-.89l8.15-.009v3.012c0 .88.713 1.594 1.594 1.594l2.95-.008.033 13.302a.891.891 0 0 1-.89.891ZM8.95 17.767v-3.826a7.85 7.85 0 0 1 1.19-.081c.74 0 1.22.133 1.596.416.405.3.659.78.659 1.469 0 .745-.272 1.26-.648 1.578-.41.34-1.034.502-1.797.502-.457 0-.78-.029-1-.058Zm6.309-2.265v.716h-1.4v1.567h-.884V13.89h2.382v.722H13.86v.89h1.399Z"
        fill="#FFF"
      />
    </svg>
  )
}
PrintPdf.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};